import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: {}, // Store user data
  fcmToken: "",
};

const authUserSlice = createSlice({
  name: "authUser",
  initialState,
  reducers: {
    logedInUser: (state, action) => {
      state.userInfo = action.payload;
    },
    setFcmToken: (state, action) => {
      state.fcmToken = action.payload;
    },
    logOutUser: (state) => {
      state.userInfo = {};
    },
  },
});

export const { logedInUser, logOutUser, setFcmToken } = authUserSlice.actions;
export default authUserSlice.reducer;
